import { combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { take, tap } from 'rxjs/operators';

import { Paths } from '@config/paths.config';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-cart-funnel-header-block',
  templateUrl: './cart-funnel-header-block.component.html',
})
export class CartFunnelHeaderBlockComponent {
  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
  ) {}

  back(): void {
    combineLatest([
      this.cartFunnelSelector.selectDisplayableStepsIds,
      this.cartFunnelSelector.selectActiveStepId,
    ])
      .pipe(
        take(1),
        tap(([displayableStepsIds, activeStepId]) => {
          if (!activeStepId) {
            this.analyticsService.log({
              level: 'debug',
              label: '#DOOD-1250 Navigate',
              message: {
                from: 'CartFunnelHeaderBlockComponent Ligne°39',
                target: [this.routerHelper.translateRoute(Paths.Cart)],
                currentLocation: window.location.pathname,
              },
            });
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }
          const activeStepIndex = displayableStepsIds.indexOf(activeStepId);

          if (activeStepIndex === 0) {
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }

          if (activeStepIndex === -1) {
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }

          this.cartFunnelDispatcher.setActive(displayableStepsIds[activeStepIndex - 1]);
        }),
      )
      .subscribe();
  }
}
